// client/src/components/creditAssignment/creditAssignmentApi.js
//
// Helper axios per il prodotto "Cessione del credito". Modulo dedicato,
// separato dalle utility dei Crediti IVA.

import axios from 'axios';

const BASE = '/api/credit-assignment';

/* --- Aziende abilitate (admin) --- */
export const fetchEnabledCompanies = () =>
  axios.get(`${BASE}/companies`).then((r) => r.data.companies || []);

export const searchAvailableCompanies = (search) =>
  axios
    .get(`${BASE}/companies/available`, { params: { search: search || undefined } })
    .then((r) => r.data.organizations || []);

export const enableCompany = (organizationId) =>
  axios.post(`${BASE}/companies`, { organizationId }).then((r) => r.data.company);

/* --- Accesso sidebar (company) --- */
export const fetchCompanyAccess = () =>
  axios.get(`${BASE}/access`).then((r) => r.data.enabled === true);

/* --- Anagrafiche clienti --- */
export const fetchClients = (companyId) =>
  axios
    .get(`${BASE}/clients`, { params: companyId ? { company: companyId } : undefined })
    .then((r) => r.data.clients || []);

export const createClient = (payload) =>
  axios.post(`${BASE}/clients`, payload).then((r) => r.data.client);

export const updateClient = (id, payload) =>
  axios.put(`${BASE}/clients/${id}`, payload).then((r) => r.data.client);

/* --- Richieste --- */
export const fetchRequests = () =>
  axios.get(`${BASE}/requests`).then((r) => r.data.requests || []);

export const fetchRequestById = (id) =>
  axios.get(`${BASE}/requests/${id}`).then((r) => r.data.request);

export const createRequest = ({ clientId, invoiceAmount, invoice }) => {
  const fd = new FormData();
  fd.append('clientId', clientId);
  fd.append('invoiceAmount', invoiceAmount);
  fd.append('invoice', invoice);
  return axios.post(`${BASE}/requests`, fd).then((r) => r.data.request);
};

export const setRequestTerms = (id, payload) =>
  axios.put(`${BASE}/requests/${id}/terms`, payload).then((r) => r.data.request);

export const confirmRequest = (id) =>
  axios.post(`${BASE}/requests/${id}/confirm`).then((r) => r.data.request);

export const downloadRequestAttachment = async (id, attachment) => {
  const res = await axios.get(`${BASE}/requests/${id}/attachment`, { responseType: 'blob' });
  const blobUrl = window.URL.createObjectURL(
    new Blob([res.data], { type: attachment?.mimeType || 'application/octet-stream' })
  );
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = attachment?.originalName || 'fattura';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};

// Whitelist client, allineata al controller: pdf, jpg/jpeg, png, doc/docx.
export const CA_ACCEPT_ATTR = '.pdf,.jpg,.jpeg,.png,.doc,.docx';
export const CA_ALLOWED_TYPES = [
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];
export const CA_MAX_SIZE = 20 * 1024 * 1024;
